import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "flood-profile",
  ref: "root"
}
const _hoisted_2 = {
  key: 0,
  class: "placeholder-glow",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "text-muted mb-0"
}
const _hoisted_4 = {
  key: 0,
  class: "alert alert-warning py-2 mb-3"
}
const _hoisted_5 = { class: "row g-4" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "flood-profile__level" }
const _hoisted_8 = { class: "flood-profile__level-value" }
const _hoisted_9 = { class: "flood-profile__summary" }
const _hoisted_10 = { class: "flood-profile__scale" }
const _hoisted_11 = { class: "flood-profile__facts" }
const _hoisted_12 = {
  key: 0,
  class: "flood-profile__muted"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "flood-profile__muted"
}
const _hoisted_16 = {
  key: 1,
  class: "flood-profile__muted"
}
const _hoisted_17 = {
  key: 2,
  class: "flood-profile__muted"
}
const _hoisted_18 = {
  key: 0,
  class: "flood-profile__muted"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "flood-profile__muted"
}
const _hoisted_21 = {
  key: 0,
  class: "flood-profile__muted"
}
const _hoisted_22 = { class: "flood-profile__muted" }
const _hoisted_23 = { class: "flood-profile__muted" }
const _hoisted_24 = {
  key: 0,
  class: "flood-profile__muted"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "flood-profile__muted"
}
const _hoisted_27 = { class: "col-lg-6" }
const _hoisted_28 = { class: "flood-profile__help list-unstyled mb-3" }
const _hoisted_29 = { class: "flood-profile__map-cta" }
const _hoisted_30 = ["data-bs-target", "aria-controls"]
const _hoisted_31 = { class: "flood-profile__attribution" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"row g-4\"><div class=\"col-lg-6\"><span class=\"placeholder flood-profile__placeholder w-100 rounded mb-3\"></span><span class=\"placeholder col-8 mb-2\"></span><span class=\"placeholder col-6\"></span></div><div class=\"col-lg-6\"><span class=\"placeholder col-7 mb-2\"></span><span class=\"placeholder col-9 mb-2\"></span><span class=\"placeholder col-8\"></span></div></div>", 1)
        ]))]))
      : (_ctx.state === 'failed' || _ctx.profile === null)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Údaje o povodňovém riziku se nepodařilo načíst."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.imprecision !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.imprecision), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "flood-profile__hero",
                  style: _normalizeStyle({'--flood-risk-color': _ctx.risk.color})
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.risk.label), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "flood-profile__level-caption" }, [
                      _createTextVNode("nebezpečí povodně"),
                      _createElementVNode("br"),
                      _createTextVNode("parametr „Možnosti záplav“")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.summary), 1),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scale, (step) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: step.key,
                        class: _normalizeClass(["flood-profile__scale-step", {'flood-profile__scale-step--active': step.active}]),
                        style: _normalizeStyle({'--step-color': step.color})
                      }, _toDisplayString(step.label), 7))
                    }), 128))
                  ])
                ], 4),
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("th", null, "Záplavová území", -1)),
                      (!_ctx.profile.floodZonesAvailable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.dataUnavailable), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (zone) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: zone.key,
                                class: _normalizeClass(["flood-profile__zone", {'flood-profile__zone--outside': !zone.reaches}]),
                                style: _normalizeStyle({'--zone-color': zone.color}),
                                title: zone.reaches ? 'voda dosahuje k místu' : 'voda k místu nedosahuje'
                              }, _toDisplayString(zone.label), 15, _hoisted_14))
                            }), 128)),
                            (_ctx.profile.streamName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "tok " + _toDisplayString(_ctx.profile.streamName), 1))
                              : (_ctx.profile.distanceToQ100Metres !== null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " nejbližší hranice 100leté vody " + _toDisplayString(_ctx.distanceToQ100), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_17, "žádné stanovené záplavové území do 5 km"))
                          ]))
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("th", null, "Aktivní zóna", -1)),
                      (!_ctx.profile.floodZonesAvailable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.dataUnavailable), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_19, [
                            (_ctx.inActiveZone)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "ano", -1)),
                                  _cache[6] || (_cache[6] = _createTextVNode(" – v aktivní zóně záplavového území platí zákaz staveb podle vodního zákona", -1))
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_20, "ne"))
                          ]))
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, "Povodňové ohrožení", -1)),
                      _createElementVNode("td", null, [
                        (!_ctx.profile.hazardMapAvailable)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "mapa ohrožení pro tuto lokalitu není zpracována"))
                          : (_ctx.hazard !== null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("span", {
                                  class: "flood-profile__swatch",
                                  style: _normalizeStyle({backgroundColor: _ctx.hazard.color})
                                }, null, 4),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.hazard.label), 1),
                                _createElementVNode("span", _hoisted_22, " (stav " + _toDisplayString(_ctx.profile.hazardMapVersion) + ")", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _cache[8] || (_cache[8] = _createTextVNode(" mimo zaplavované území ", -1)),
                                _createElementVNode("span", _hoisted_23, "(stav " + _toDisplayString(_ctx.profile.hazardMapVersion) + ")", 1)
                              ], 64))
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("th", null, "Zaznamenané povodně", -1)),
                      (!_ctx.profile.floodZonesAvailable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(_ctx.dataUnavailable), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_25, [
                            (_ctx.floods.length > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.floods.join(', ')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_26, "žádná z evidovaných povodní (1880–2013) místo nezaplavila"))
                          ]))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("ul", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.help, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.lead,
                      class: "mb-2"
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(item.lead), 1),
                      _createTextVNode(" " + _toDisplayString(item.text), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flood-profile__map-cta-title" }, "Jak vypadá povodňová mapa okolí?", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flood-profile__map-cta-text" }, " Záplavová území, aktivní zóna a kategorie ohrožení nad leteckým snímkem místa. ", -1)),
                  (_ctx.unfoldMapId !== null)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": '#' + _ctx.unfoldMapId,
                        "aria-controls": _ctx.unfoldMapId,
                        "aria-expanded": "false"
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }, null, -1),
                        _createTextVNode("Zobrazit povodňovou mapu okolí ", -1)
                      ]))], 8, _hoisted_30))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }, null, -1),
                        _createTextVNode("Otevřít povodňovou mapu okolí ", -1)
                      ]))]))
                ]),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.disclaimer) + " " + _toDisplayString(_ctx.attribution), 1)
              ])
            ])
          ], 64))
  ], 512))
}